import { render } from "./EditTrip.vue?vue&type=template&id=91437cd2"
import script from "./EditTrip.vue?vue&type=script&lang=js"
export * from "./EditTrip.vue?vue&type=script&lang=js"
script.render = render

export default script